<ng-container>
  <div class="search-wrapper">
    <input (input)="search($event.target.value)" [value]="queryValue || ''" class="form-control" />
    <i class="fas fa-search"></i>
  </div>
</ng-container>
